import React from 'react';
import styles from './footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>
        © {new Date().getFullYear()} All rights reserved. Images are the
        property of their respective owners and may not be reproduced without
        written permission.
      </p>
    </footer>
  );
};

export default Footer;
